<template>
<a :href="profileUrl" class="button mb-5" v-if="organization && organization.profileUrl" target="_blank">
    View My Profile
</a>
</template>

<script>

    import {mapGetters} from 'vuex';

    export default {
        name: 'PublicProfileLink',
        props: {},
        components:{},
        data: () => ({

        }),
        computed: {
            ...mapGetters({
                organization: 'organization',
                user: 'user'
            }),
            profileUrl() {
                return this.organization && this.organization.profileUrl ? this.organization.profileUrl : ''
            }
        },
        watch: {
            user() {
                this.getOrganization()
            }
        },
        methods: {
            getOrganization() {
                let id;

                if( _.isEmpty(this.$route.params) ) {
                    id = this.user.organization_id
                } else {
                    id = this.$route.params.id
                }

                this.$store.dispatch('getOrganization', {id: id})
            }
        },
        mounted() {}
    }
</script>
